import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

@Component({
  selector: 'app-partnership-setup',
  templateUrl: './partnership-setup.component.html',
  styleUrls: ['./partnership-setup.component.css']
})
export class PartnershipSetupComponent implements OnInit {
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  dataresult: any = [];
  recordsperpage: number = 25;
  showLoader: boolean;
  groupIncentive2: any;
  groupIncentive3: any;
  groupIncentive4: any;
  groupIncentive5: any;
  onlyview: boolean;
  constructor(private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
  }

  ngOnInit() {
    this.model = {
      id: '',
      name: '',
      mobile: '',
      quantity: '',
      percentage: '',
      address: '',
      code: '',
      person_name: ''
    }
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));

    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.partnership_id) {
        this.headerLabel = 'Edit';
        this.model.id = p.partnership_id;
        this.getPartnershipCoupon(p.partnership_id);
        this.getPartnership(p.partnership_id);
      } else {
        this.headerLabel = 'New';
        this.getPartnershipCoupon('');
      }
    }, error => { alert('Network Error params API'); });
  }

  getPartnershipCoupon(partnership_id) {
    this.loginservice.getPartnershipCoupon(partnership_id, this.currentUser)
      .subscribe(
        data => {
          if (data['data'].length > 0) {
            this.dataresult = data['data'];
          } else {
            this.dataresult = [];
          }
        }, error => { alert('Network Error getPartnershipCoupon API'); });
  }


  getPartnership(partnership_id) {
    this.showLoader = true;
    this.loginservice.getPartnership(partnership_id, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.model = data['comp_details'][0];
          } else {
            this.model = {
              id: '',
              name: '',
              mobile: '',
              quantity: '',
              percentage: '',
              address: '',
              code: '',
              person_name: ''
            }
          }
          this.showLoader = false;
        },
        error => {
          alert('Network Error getPartnership API');
          this.showLoader = false;
        });

  }

  save() {
    if (!this.model.mobile || this.model.mobile.length !== 10) {
      this._flashMessagesService.show('Mobile number must be 10 digits long!', { cssClass: 'alert-danger' });
      alert('Mobile number must be 10 digits long!');
      return;
    }
    this.showLoader = true;
    this.loginservice.savePartnershipSetup(this.model, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.showLoader = false;
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
          this.router.navigate(['/partnership-grid']);
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          this.showLoader = false;
        }
      },
      error => {
        this.showLoader = false;
        alert('Network Error savePartnershipSetup API');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/partnership-setup/partnership-setup.component.ts